{
  "eyebrow": "Du er inne",
  "title": "Velkommen til Done-it, {{company}}.",
  "sub": "Din 30-dagers prøveperiode for {{plan}} er aktiv. Tre neste steg.",
  "next1": {
    "title": "Last ned mobilappen",
    "desc": "Send installasjonslenken til teamet ditt via SMS eller e-post.",
    "cta": "Send invitasjonslenke"
  },
  "next2": {
    "title": "Inviter teamet ditt",
    "desc": "Importer ansatte fra CSV eller legg dem til én etter én.",
    "cta": "Åpne administrator"
  },
  "next3": {
    "title": "Se en 4-minutters omvisning",
    "desc": "Se hvordan du setter opp ditt første prosjekt og lokasjoner.",
    "cta": "Se video"
  },
  "cta": "Til dashbordet",
  "receipt": "En kvittering og en velkomst-e-post er på vei til {{email}}.",
  "fallbacks": {
    "company": "bedriften din",
    "plan": "abonnementet ditt",
    "inbox": "innboksen din"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "{{plan}}-kontoen din er aktiv — gratis for alltid. Tre ting å gjøre videre."
}
